/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */

export enum StateStep {
	INITIAL,
	VALIDATE,
	INSERTION_POINT,
	ESID_DISAMBIGUATION,
	MAP_VARIANCE_REASONS,
	RESULTS,
	TICKET_CORRECTION,
}

export enum ScheduleTemplateFileFormat {
	Touchplan = 'touchplan',
	P6Excel = 'p6Excel',
	OPCExcel = 'opcExcel',
	MSPExcel = 'mspExcel',
	Boardscan = 'boardscan',
}

export enum ImportType {
	CREATE_UNIQUE_ESIDS = 'createUniqueEsids',
	CREATE = 'create',
	UPDATE = 'update',
	CREATE_AND_UPDATE = 'createAndUpdate',
}

export enum ActiveLineStrategy {
	PRESERVE_PULL_TICKETS = 'preservePullTickets',
	ACTIVATE_PULL_TICKETS = 'activatePullTickets',
	LEAVE_ACTIVE_LINE = 'leaveActiveLine',
}

export enum SwimlanePlacement {
	WBS = 'wbs',
	ROLE = 'role',
	NONE = 'none',
	LOCATION = 'location',
}

export enum TicketImportFileUploadStatus {
	Waiting,
	Success,
	Error,
}

export enum TicketImportErrorType {
	UNRECOVERABLE = 'UNRECOVERABLE',
	RECOVERABLE = 'RECOVERABLE',
}

export enum ImportScope {
	TICKETS = 'tickets',
	PREDECESSORS = 'predecessors',
}

//BEGIN PLACEHOLDER REPLACE AS PART OF TP-5902
//duplicated from nest
/**
 * Enum representing possible result statuses for validating tickets.
 */
export enum EsidDisambiguationTicketActions {
	Ignore = 'ignore',
	Update = 'update',
	Unset = 'unset',
}
//END PLACEHOLDER REPLACE AS PART OF TP-5902

export enum BackdropType {
	COMPLETE = 'complete',
	PARTIAL = 'partial',
}

export interface IESIDDataItem {
	externalScheduleId: string;
	createNew?: boolean;
	tickets?: Record<string, { action: EsidDisambiguationTicketActions }>;
}

export type IESIDData = Record<string, IESIDDataItem>;

export interface IImportVariance {
	id: string;
	comment?: string;
}

export interface IImportVariances {
	[ticketId: string]: IImportVariance;
}

export enum TicketOverride {
	CUT_DATES = 'cutDates',
}

export interface ITicketOverrides {
	[ticketId: string]: TicketOverride[];
}

export const TicketImportSupportedFormats: ReadonlyArray<string> = [
	'.xlsx',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export interface ITicketImportResponseMetadata {
	tickets?: {
		created?: number;
		updated?: number;
		notCreated?: number;
	};
	dependencies?: {
		created?: number;
		notCreated?: number;
	};
	swimlanes?: {
		created?: number;
	};
	errorDescription?: string;
	snapshotId?: string;
}

export enum TicketImportOperationType {
	import = 'import',
	export = 'export',
	update = 'update',
}

export enum ImportResponse {
	success = 'success',
	error = 'error',
}

export interface ITicketProcessBoardScanTicketsResponse {
	message: string;
	successCount: number;
	totalTicketCount: number;
	warningCount: number;
}
